import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "gallery",
  class: "py-16 bg-white"
}
const _hoisted_2 = { class: "container mx-auto px-4" }
const _hoisted_3 = {
  ref: "gridContainer",
  class: "max-w-5xl mx-auto"
}
const _hoisted_4 = { class: "hidden md:flex flex-col gap-4" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "flex-1 overflow-hidden" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "flex-1 overflow-hidden" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { class: "flex-1 overflow-hidden" }
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { class: "md:hidden flex flex-col gap-2" }
const _hoisted_21 = ["src", "alt"]
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = { class: "flex-1 overflow-hidden" }
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = { class: "flex-1 overflow-hidden" }
const _hoisted_26 = ["src", "alt"]
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = ["src", "alt"]
const _hoisted_29 = ["src", "alt"]
const _hoisted_30 = { class: "flex-1 overflow-hidden" }
const _hoisted_31 = ["src", "alt"]
const _hoisted_32 = ["src", "alt"]
const _hoisted_33 = ["src", "alt"]
const _hoisted_34 = ["src", "alt"]
const _hoisted_35 = { class: "flex-1 overflow-hidden" }
const _hoisted_36 = ["src", "alt"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.images.length > 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "section-title text-gascon-blue" }, "Dans vos cuisines !", -1 /* CACHED */)),
          _createCommentVNode(" Decorative line "),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex justify-center mb-12" }, [
            _createElementVNode("div", { class: "w-16 h-1 bg-gascon-gold" })
          ], -1 /* CACHED */)),
          _createCommentVNode(" Image mosaic grid "),
          _createCommentVNode(" All images same height, 3 squares + 1 rectangle per row (desktop) "),
          _createCommentVNode(" 2 squares + 1 rectangle per row (mobile) "),
          _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" Desktop layout "),
            _createElementVNode("div", _hoisted_4, [
              _createCommentVNode(" Row 1: square, square, RECT, square "),
              _createElementVNode("div", {
                class: "flex gap-4",
                style: _normalizeStyle({ height: $options.rowHeight + 'px' })
              }, [
                _createElementVNode("div", {
                  ref: "squareRef",
                  class: "overflow-hidden",
                  style: _normalizeStyle({ width: $options.rowHeight + 'px', height: $options.rowHeight + 'px' })
                }, [
                  ($options.displayImages[0])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[0].url,
                        alt: $options.displayImages[0].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_5))
                    : _createCommentVNode("v-if", true)
                ], 4 /* STYLE */),
                _createElementVNode("div", {
                  class: "overflow-hidden",
                  style: _normalizeStyle({ width: $options.rowHeight + 'px', height: $options.rowHeight + 'px' })
                }, [
                  ($options.displayImages[1])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[1].url,
                        alt: $options.displayImages[1].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_6))
                    : _createCommentVNode("v-if", true)
                ], 4 /* STYLE */),
                _createElementVNode("div", _hoisted_7, [
                  ($options.displayImages[2])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[2].url,
                        alt: $options.displayImages[2].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_8))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", {
                  class: "overflow-hidden",
                  style: _normalizeStyle({ width: $options.rowHeight + 'px', height: $options.rowHeight + 'px' })
                }, [
                  ($options.displayImages[3])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[3].url,
                        alt: $options.displayImages[3].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_9))
                    : _createCommentVNode("v-if", true)
                ], 4 /* STYLE */)
              ], 4 /* STYLE */),
              _createCommentVNode(" Row 2: RECT, square, square, square "),
              _createElementVNode("div", {
                class: "flex gap-4",
                style: _normalizeStyle({ height: $options.rowHeight + 'px' })
              }, [
                _createElementVNode("div", _hoisted_10, [
                  ($options.displayImages[4])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[4].url,
                        alt: $options.displayImages[4].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_11))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", {
                  class: "overflow-hidden",
                  style: _normalizeStyle({ width: $options.rowHeight + 'px', height: $options.rowHeight + 'px' })
                }, [
                  ($options.displayImages[5])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[5].url,
                        alt: $options.displayImages[5].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_12))
                    : _createCommentVNode("v-if", true)
                ], 4 /* STYLE */),
                _createElementVNode("div", {
                  class: "overflow-hidden",
                  style: _normalizeStyle({ width: $options.rowHeight + 'px', height: $options.rowHeight + 'px' })
                }, [
                  ($options.displayImages[6])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[6].url,
                        alt: $options.displayImages[6].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_13))
                    : _createCommentVNode("v-if", true)
                ], 4 /* STYLE */),
                _createElementVNode("div", {
                  class: "overflow-hidden",
                  style: _normalizeStyle({ width: $options.rowHeight + 'px', height: $options.rowHeight + 'px' })
                }, [
                  ($options.displayImages[7])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[7].url,
                        alt: $options.displayImages[7].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_14))
                    : _createCommentVNode("v-if", true)
                ], 4 /* STYLE */)
              ], 4 /* STYLE */),
              _createCommentVNode(" Row 3: square, RECT, square, square "),
              _createElementVNode("div", {
                class: "flex gap-4",
                style: _normalizeStyle({ height: $options.rowHeight + 'px' })
              }, [
                _createElementVNode("div", {
                  class: "overflow-hidden",
                  style: _normalizeStyle({ width: $options.rowHeight + 'px', height: $options.rowHeight + 'px' })
                }, [
                  ($options.displayImages[8])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[8].url,
                        alt: $options.displayImages[8].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_15))
                    : _createCommentVNode("v-if", true)
                ], 4 /* STYLE */),
                _createElementVNode("div", _hoisted_16, [
                  ($options.displayImages[9])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[9].url,
                        alt: $options.displayImages[9].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_17))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", {
                  class: "overflow-hidden",
                  style: _normalizeStyle({ width: $options.rowHeight + 'px', height: $options.rowHeight + 'px' })
                }, [
                  ($options.displayImages[10])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[10].url,
                        alt: $options.displayImages[10].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_18))
                    : _createCommentVNode("v-if", true)
                ], 4 /* STYLE */),
                _createElementVNode("div", {
                  class: "overflow-hidden",
                  style: _normalizeStyle({ width: $options.rowHeight + 'px', height: $options.rowHeight + 'px' })
                }, [
                  ($options.displayImages[11])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[11].url,
                        alt: $options.displayImages[11].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_19))
                    : _createCommentVNode("v-if", true)
                ], 4 /* STYLE */)
              ], 4 /* STYLE */)
            ]),
            _createCommentVNode(" Mobile layout "),
            _createElementVNode("div", _hoisted_20, [
              _createCommentVNode(" Row 1: square, square, RECT "),
              _createElementVNode("div", {
                class: "flex gap-2",
                style: _normalizeStyle({ height: $options.mobileRowHeight + 'px' })
              }, [
                _createElementVNode("div", {
                  ref: "mobileContainerRef",
                  class: "overflow-hidden",
                  style: _normalizeStyle({ width: $options.mobileRowHeight + 'px', height: $options.mobileRowHeight + 'px' })
                }, [
                  ($options.displayImages[0])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[0].url,
                        alt: $options.displayImages[0].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_21))
                    : _createCommentVNode("v-if", true)
                ], 4 /* STYLE */),
                _createElementVNode("div", {
                  class: "overflow-hidden",
                  style: _normalizeStyle({ width: $options.mobileRowHeight + 'px', height: $options.mobileRowHeight + 'px' })
                }, [
                  ($options.displayImages[1])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[1].url,
                        alt: $options.displayImages[1].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_22))
                    : _createCommentVNode("v-if", true)
                ], 4 /* STYLE */),
                _createElementVNode("div", _hoisted_23, [
                  ($options.displayImages[2])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[2].url,
                        alt: $options.displayImages[2].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_24))
                    : _createCommentVNode("v-if", true)
                ])
              ], 4 /* STYLE */),
              _createCommentVNode(" Row 2: RECT, square, square "),
              _createElementVNode("div", {
                class: "flex gap-2",
                style: _normalizeStyle({ height: $options.mobileRowHeight + 'px' })
              }, [
                _createElementVNode("div", _hoisted_25, [
                  ($options.displayImages[3])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[3].url,
                        alt: $options.displayImages[3].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_26))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", {
                  class: "overflow-hidden",
                  style: _normalizeStyle({ width: $options.mobileRowHeight + 'px', height: $options.mobileRowHeight + 'px' })
                }, [
                  ($options.displayImages[4])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[4].url,
                        alt: $options.displayImages[4].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_27))
                    : _createCommentVNode("v-if", true)
                ], 4 /* STYLE */),
                _createElementVNode("div", {
                  class: "overflow-hidden",
                  style: _normalizeStyle({ width: $options.mobileRowHeight + 'px', height: $options.mobileRowHeight + 'px' })
                }, [
                  ($options.displayImages[5])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[5].url,
                        alt: $options.displayImages[5].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_28))
                    : _createCommentVNode("v-if", true)
                ], 4 /* STYLE */)
              ], 4 /* STYLE */),
              _createCommentVNode(" Row 3: square, RECT, square "),
              _createElementVNode("div", {
                class: "flex gap-2",
                style: _normalizeStyle({ height: $options.mobileRowHeight + 'px' })
              }, [
                _createElementVNode("div", {
                  class: "overflow-hidden",
                  style: _normalizeStyle({ width: $options.mobileRowHeight + 'px', height: $options.mobileRowHeight + 'px' })
                }, [
                  ($options.displayImages[6])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[6].url,
                        alt: $options.displayImages[6].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_29))
                    : _createCommentVNode("v-if", true)
                ], 4 /* STYLE */),
                _createElementVNode("div", _hoisted_30, [
                  ($options.displayImages[7])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[7].url,
                        alt: $options.displayImages[7].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_31))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", {
                  class: "overflow-hidden",
                  style: _normalizeStyle({ width: $options.mobileRowHeight + 'px', height: $options.mobileRowHeight + 'px' })
                }, [
                  ($options.displayImages[8])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[8].url,
                        alt: $options.displayImages[8].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_32))
                    : _createCommentVNode("v-if", true)
                ], 4 /* STYLE */)
              ], 4 /* STYLE */),
              _createCommentVNode(" Row 4: square, square, RECT "),
              _createElementVNode("div", {
                class: "flex gap-2",
                style: _normalizeStyle({ height: $options.mobileRowHeight + 'px' })
              }, [
                _createElementVNode("div", {
                  class: "overflow-hidden",
                  style: _normalizeStyle({ width: $options.mobileRowHeight + 'px', height: $options.mobileRowHeight + 'px' })
                }, [
                  ($options.displayImages[9])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[9].url,
                        alt: $options.displayImages[9].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_33))
                    : _createCommentVNode("v-if", true)
                ], 4 /* STYLE */),
                _createElementVNode("div", {
                  class: "overflow-hidden",
                  style: _normalizeStyle({ width: $options.mobileRowHeight + 'px', height: $options.mobileRowHeight + 'px' })
                }, [
                  ($options.displayImages[10])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[10].url,
                        alt: $options.displayImages[10].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_34))
                    : _createCommentVNode("v-if", true)
                ], 4 /* STYLE */),
                _createElementVNode("div", _hoisted_35, [
                  ($options.displayImages[11])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $options.displayImages[11].url,
                        alt: $options.displayImages[11].alt || 'Plat de nos clients',
                        class: "w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      }, null, 8 /* PROPS */, _hoisted_36))
                    : _createCommentVNode("v-if", true)
                ])
              ], 4 /* STYLE */)
            ])
          ], 512 /* NEED_PATCH */)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}